module.exports = __webpack_public_path__ + "img/thumbnail_SpottedHyena_j_normal.03d7081f.png";